// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".autoplay-container[data-v-365573ab]{display:flex;align-items:center;gap:.5rem}.speed-dropdown[data-v-365573ab]{margin-left:.5rem}.speed-select[data-v-365573ab]{width:60px;height:28px}.speed-select[data-v-365573ab] .p-dropdown{padding:.25rem;font-size:.875rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
